import { render, staticRenderFns } from "./PageResult.vue?vue&type=template&id=415dd637&scoped=true&"
import script from "./PageResult.vue?vue&type=script&lang=ts&"
export * from "./PageResult.vue?vue&type=script&lang=ts&"
import style0 from "./PageResult.vue?vue&type=style&index=0&id=415dd637&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415dd637",
  null
  
)

export default component.exports